<template>
	<div>
		<div class="data">
			<div class="titulo"><h3>Documentos emitidos del período</h3></div>
			<div v-if="nodata == true" class="alert alert-primary text-center" role="alert">{{ mensaje }}</div>
			<div class="tabla" v-if="nodata == false && documentos.length > 0">
				<div class="row">
					<div class="col-4">
						<div class="filtro">
							<b-input v-model="filtro" type="search" id="filterInput" placeholder="Búsqueda"></b-input>
						</div>
					</div>
					<div class="col-8 text-right">
						<div class="excel">
							<download-excel :export-fields="campos" :data="documentos" :name="'doctos_emitidos_' + getPeriodo"><i class="fas fa-file-excel fa-fw" /> Excel</download-excel>
						</div>
					</div>
				</div>
				<div class="data">
					<b-table striped hover no-border-collapse head-variant="light" :per-page="perPage" :current-page="currentPage" :items="getDocumentos" :fields="columnas">
						<template #cell(id_documentType)="data">
							{{ getBsale(data.value) }}
						</template>
						<template #cell(emissionDate)="data">
							{{ getFecha(data.value) }}
						</template>
						<template #cell(expirationDate)="data">
							{{ getFecha(data.value) }}
						</template>
						<template #cell(MONTO_FACTURA)="data">
							{{ Intl.NumberFormat('es-CL').format(data.value) }}
						</template>
						<template #cell(totalAmount)="data">
							{{ Intl.NumberFormat('es-CL').format(data.value) }}
						</template>
						<template #cell(MONTO_NOTA_CREDITO)="data">
							{{ Intl.NumberFormat('es-CL').format(data.value) }}
						</template>
						<template #cell(MONTO_TOTAL)="data">
							{{ Intl.NumberFormat('es-CL').format(data.value) }}
						</template>
					</b-table>
					<b-pagination size="sm" v-model="currentPage" :total-rows="totalDoctos" :per-page="perPage"></b-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import bsale from "./../../bsale.json"
	import DownloadExcel from "vue-json-excel"


	export default 
	{
		name: "Emitidos",
		components: { DownloadExcel },
		props: {
			info: String,
		},
		data() {
			return {
				periodo: "",
				nodata: false, // Flag que indica si la respuesta del ws trajo datos o no, para mostrar el mensaje en la pantalla
				mensaje: "",
				documentos: [], // Arreglo con el total de documentos del periodo
				documento: {}, // Documento seleccionado para refacturacion
				mostrar_generar_factura: false,
				columnas: [ 
					{ key: "id_documentType", label: "Document Type ID", sortable: true, class: "text-nowrap" },
					{ key: "emissionDate", label: "Emission Date", sortable: true, class:"text-nowrap" },
					{ key: "expirationDate", label: "Expiration Date", sortable: true, class:"text-nowrap" },
					{ key: "code", label: "Code", sortable: true, class: "text-nowrap" },
					{ key: "client_id", label: "Client ID", sortable: true, class: "text-nowrap" },
					{ key: "client_id_madre", label: "Client ID Madre", sortable: true, class: "text-nowrap" },
					{ key: "company", label: "Company", sortable: true, class: "text-nowrap" },
					{ key: "number", label: "Folio", sortable: true, class: "text-nowrap text-right" },
					{ key: "fc_Folio", label: "FC Folio", sortable: false, class: "text-nowrap" },
					{ key: "MONTO_TOTAL", label: "Exento", sortable: true, class: "text-nowrap text-right" },
					{ key: "netAmount", label: "Monto neto", sortable: true, class: "text-nowrap" },
					{ key: "taxAmount", label: "Iva", sortable: true, class: "text-nowrap" },
					{ key: "totalAmount", label: "Total Amount", sortable: true, class: "text-nowrap text-right" },
					{ key: "MONTO_FACTURA", label: "Orden de Factura", sortable: true, class: "text-nowrap text-right" },
					{ key: "MONTO_NOTA_CREDITO", label: "Monto Nota Crédito", sortable: true, class: "text-nowrap text-right" },
					{ key: "especial", label: "Especial", sortable: true, class: "text-nowrap" },
					{ key: "centro_costo", label: "Centro Costo", sortable: true, class: "text-nowrap" },
					{ key: "orden_compra", label: "Orden Compra", sortable: true, class: "text-nowrap" },
					{ key: "desglose", label: "Desglose", sortable: true, class: "text-nowrap" },
					{ key: "hes", label: "HES", sortable: true, class: "text-nowrap" },
					{ key: "CIUDAD_FAC", label: "Ciudad Fac", sortable: true, class: "text-nowrap" },
					{ key: "CLIENTE_CITY", label: "Cliente City", sortable: true, class: "text-nowrap" },
					{ key: "PAYMENT_TERMS", label: "Payment Terms", sortable: true, class: "text-nowrap" },
					{ key: "metodo_pago", label: "Método Pago", sortable: true, class: "text-nowrap" },
					{ key: "GIROS", label: "Giros", sortable: true, class: "text-nowrap" },
					{ key: "grupo_economico", label: "Grupo Económico", sortable: true, class: "text-nowrap" },
					{ key: "CLIENT_ADDRESS", label: "Client Address", sortable: true, class: "text-nowrap" },
					{ key: "nombre_admin", label: "Nombre Admin", sortable: true, class: "text-nowrap" },
					{ key: "correo_admin", label: "Correo Admin", sortable: true, class: "text-nowrap" },
					{ key: "telefono_admin", label: "Teléfono Admin", sortable: true, class: "text-nowrap" },
					{ key: "nombre_cob", label: "Nombre Cob", sortable: true, class: "text-nowrap" },
					{ key: "correo_cob", label: "Correo Cob", sortable: true, class: "text-nowrap" },
					{ key: "telefono_cob", label: "Teléfono Cob", sortable: true, class: "text-nowrap" },
					{ key: "CORREOS_FAC", label: "Correos Fac", sortable: true, class: "text-nowrap" },
					{ key: "sales_rep", label: "Sales Rep", sortable: true, class: "text-nowrap" },
					{ key: "soporte", label: "Soporte", sortable: true, class: "text-nowrap" },
					{ key: "NOMINA", label: "Nómina", sortable: true, class: "text-nowrap" },
					{ key: "MONTO_TOTAL", label: "Monto Total", sortable: true, class: "text-nowrap text-right" },
					{ key: "CLIENTE_NAME", label: "Cliente Name", sortable: true, class: "text-nowrap" },
					{ key: "categoria", label: "Categoría", sortable: true, class: "text-nowrap" },
					{ key: "Detalle_CC_Facturacion", label: "Detalle CC Facturación", sortable: true, class: "text-nowrap" },										
				],
				campos: {
					"DOCUMENT TYPE ID": {
						field: "id_documentType",
						callback: (value) => { return this.getBsale(value); }
					},
					"EMISSION DATE": {
						field: "emissionDate",
						callback: (value) => { return this.getFecha(value); }
					},
					"EXPIRATION DATE": {
						field: "expirationDate",
						callback: (value) => { return this.getFecha(value); }
					},
					"CODE": "code",
					"CLIENT ID": "client_id",
					"CLIENT ID MADRE": "client_id_madre",
					"COMPANY": "company",
					"FOLIO": "number",
					"FC FOLIO": "fc_Folio",
					"EXENTO": "MONTO_TOTAL",
					"MONTO NETO": "netAmount",
					"IVA": "taxAmount",
					"TOTAL AMOUNT": "totalAmount",
					"ORDEN DE FACTURA": "MONTO_FACTURA",
					"MONTO NOTA CREDITO": "MONTO_NOTA_CREDITO",
					"ESPECIAL": "especial",
					"CENTRO COSTO": "centro_costo",
					"ORDEN COMPRA": "orden_compra",
					"DESGLOSE": "desglose",
					"HES": "hes",
					"CIUDAD FAC": "CIUDAD_FAC",
					"CLIENTE CITY": "CLIENTE_CITY",
					"PAYMENT TERMS": "PAYMENT_TERMS",
					"METODO PAGO": "metodo_pago",
					"GIROS": "GIROS",
					"GRUPO ECONOMICO": "grupo_economico",
					"CLIENT ADDRESS": "CLIENT_ADDRESS",
					"NOMBRE ADMIN": "nombre_admin",
					"CORREO ADMIN": "correo_admin",
					"TELEFONO ADMIN": "telefono_admin",
					"NOMBRE COB": "nombre_cob",
					"CORREO COB": "correo_cob",
					"TELEFONO COB": "telefono_cob",
					"CORREOS FAC": "CORREOS_FAC",
					"SALES REP": "sales_rep",
					"SOPORTE": "soporte",
					"NOMINA": "NOMINA",
					"MONTO TOTAL": "MONTO_TOTAL",
					"CLIENTE NAME": "CLIENTE_NAME",
					"CATEGORIA": "categoria",
					"DETALLE CC FACTURACION": "Detalle_CC_Facturacion"					
				},
				filtro: "",
				perPage: 10,
				currentPage: 1,
			}
		},
		created() {

			this.periodo = this.$periodo
		},
		computed: {

			getDocumentos() {

				return this.filtrar()
			},

			totalDoctos() {

				return this.filtrar().length
			},

			getPeriodo() {

				return this.periodo.substr(0, 7)
			}
		},
		mounted: function() {

			// Guardamos el THIS en otra variable para poder usarla aqui. No se puede usar directamente THIS en esta parte del ciclo de vida (?????)
			const that = this

			// Escuchamos por el evento "cambio-periodo", que se genera desde el componente HEADER y lo envia a todos los componentes activos
			// Actualizamos la variable local periodo y actualizamos la data

			window.event.$on("evento-cambio-periodo", function(periodo) {

				// Leemos los datos a traves del servicio rest
				that.periodo = periodo
			})

			this.leerDatos()
		},
		methods: {

			leerDatos() {

				// Ocultamos el panel con los dtos y mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

                // Llamamos al WS para traer las fichas a mostrar
				var request = { 
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "iF", 
					"operacion": "iF_periodo", 
					"data2Query": {
						"fecha_de_desde": this.periodo.substr(0, 7),
						"fecha_de_hasta": this.periodo.substr(0, 7),
					}
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					// Chequeamos si existe la propiedad mensaje_error
					// Si existe es porque hubo un problema en la llamada o no hay datos y mostramos el mensaje
					if (response.data.estatus != "OK") {

						this.nodata = true
						this.mensaje = response.data.mensajer_error
					} else {

						this.nodata = false
						this.mensaje = ""
						this.documentos = response.data.data
					}

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => { 

					// Si hubo un error, pasamos por aca
					console.log(ex.message) 

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)
				})
			},

			filtrar() {

				return this.documentos.filter((documento) => {

					return documento.CLIENTE_NAME != undefined && documento.CLIENTE_NAME.toLowerCase().includes(this.filtro.toLowerCase())
				})
			},

			getBsale(id) {

				var name = id 
				bsale.forEach(function(docto) {

					if (docto.codigo == id)
					{
						name = docto.nombre
						return false
					}
				})

				return name
			},

			getFecha(unix) {

				return moment.unix(unix).utc().format("DD-MM-YYYY")
			}
		}
	}
</script>
<style scoped>

	.titulo {
		width: 100%;
		margin-bottom: 15px;
	}

	.tabla {
		width: 100%;
	}

	.filtro {
		width: 250px;
		padding-bottom: 10px;
	}

	.excel {
		display: inline-block;
		padding: 5px 10px 5px 10px;
		background-color: black;
		color: white;
		border-radius: 4px;
	}

	.excel:hover {
		cursor: pointer;
		opacity: 0.5;
	}

	.data {
		overflow: auto;
	}

</style>
